var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"revslider",attrs:{"data-alias":_vm.getLocale + '-productos',"id":_vm.getLocale + '-productos'}})])}
var staticRenderFns = []

export { render, staticRenderFns }